<template>
    <div class="integration-link advanced-config-fields-integration">
        <v-checkbox
            v-if="!isPartner"
            v-model="linkIntegration"
            :ripple="false"
            :label="$t('message.campaigns.message.linkIntegration')"
            @change="checkIntegrationAction"
        ></v-checkbox>

        <Select
            v-if="linkIntegration"
            :data-title="$t('message.campaigns.message.integration')"
            :value="value"
            data-max-height="180px"
            :data-items="integrationsSelectOptions"
            @input="emitSelect($event)"
        ></Select>
    </div>
</template>

<script>
import Select from "@components/Select";
export default {
    components: {
        Select,
    },

    props: {
        value: {
            type: String,
        },
    },

    data() {
        return {
            linkIntegration: false,
        };
    },

    mounted() {
        this.linkIntegration = !!this.value;
    },

    computed: {
        integrations() {
            return (
                this.$store.state.integration.listIntegrationsAccessExecution ||
                []
            );
        },
        integrationsSelectOptions() {
            return this.integrations.map((integration) => {
                return {
                    id: integration.id,
                    label: integration.name,
                };
            });
        },

        isPartner() {
            return this.$store.state.users.user.tipo === "PARCEIRO";
        },
    },

    methods: {
        emitSelect(val) {
            this.$emit("select", val);
        },
        async checkIntegrationAction() {
            if (!this.linkIntegration && this.value) {
                this.$emit("select", undefined);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.integration-link {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
